module.exports = __webpack_public_path__ + "static/media/seta-direita.6a6bc05a.svg";